import { PullToRefresh as AntdMobilePullToRefresh } from "antd-mobile";
import { BasePullToRefreshProps } from "./PullToRefresh.types";
import { LoadingSpinner } from "../../LoadingSpinner";
import "./PullToRefresh.scss";

// 自定义渲染函数
const renderStatusContent = () => {
  return <LoadingSpinner size={30} />;
};

export const PullToRefresh: React.FC<BasePullToRefreshProps> = ({
  children,
  onRefresh,
  canRefresh = true,
  disabled = false,
  threshold = 30,
  headHeight = 30,
  className = "",
  testId,
}) => {
  if (!canRefresh) {
    return <>{children}</>;
  }
  const pullToRefreshClass = [
    "pull-to-refresh",
    disabled && "pull-to-refresh--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={pullToRefreshClass} data-testid={testId}>
      <AntdMobilePullToRefresh
        onRefresh={onRefresh}
        disabled={disabled}
        threshold={threshold}
        headHeight={headHeight}
        renderText={renderStatusContent}
      >
        {children}
      </AntdMobilePullToRefresh>
    </div>
  );
};

export default PullToRefresh;
